<div (click)="open.emit()"
  [cypress]="'expand_receipt'"
  class="grid__unit s-4-4 receipt-footer animated fadeIn sticky">
  <div class="tile tile--tilegraphic">
    <div class="tile__content">
      <h3 class="headingS">
        <span>{{ 'RECEIPT.TITLE' | translate }}</span>
        <span>
          ({{ totalProductCount }} {{ totalProductCount > 1 ? ('CARDS' | translate).toLowerCase() :
          ('CARD' | translate).toLowerCase() }})
        </span>
        <i class="icon icon--chevron-down-medium--nsLightBlue float-right"></i>
      </h3>
      <p>
        {{ 'RECEIPT.TOTAL' | translate }} €{{ totalReceiptPrice | priceFormat }} {{ 'RECEIPT.MONTH' | translate }}
      </p>
    </div>
  </div>
</div>
